import { SREV2 } from '../../../api/pushGenie';
import { getAclViewClassName } from '../../../restrictions/utils';

const AttachmentHistoryBt: React.FC<{
    onClick: () => void;
}> = ({ onClick }) => {
    return (
        <div onClick={onClick} className={`menuitem ${getAclViewClassName(SREV2.SEND_ATTACHMENT)}`}>
            <div>
                <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        width="12"
                        height="14"
                    >
                        <path
                            d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
                            fill="#004BA8"
                        ></path>
                    </svg>
                </div>
                <p>Sent Files</p>
            </div>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                </svg>
            </div>
        </div>
    );
};

export default AttachmentHistoryBt;
